import React, { useState } from "react";
import axios from "axios";
import {
  Box,
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Alert,
} from "@mui/material";

const CompanyForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(email);
    try {
      const response = await axios.post(
        "http://192.168.1.18:8082/companyInfo/forgot-password",
        { email } // ✅ wrap in an object to match { "email": "value" }
      );
  
      setMessage(response.data.message || "Password reset link sent!");
      setError("");
    } catch (err) {
      setError("Failed to send reset link. Please try again.");
      setMessage("");
    }
  };
  

  return (
    <Box
      sx={{
        minHeight: "81vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",

      }}
    >
      <Container maxWidth="sm">
        <Paper elevation={3} sx={{ p: 4, borderRadius: "15px" }}>
          <Typography variant="h5" textAlign="center" fontWeight="bold" mb={3}>
            Forgot Password
          </Typography>

          {message && (
            <Alert severity="success" sx={{ mb: 2 }}>
              {message}
            </Alert>
          )}
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Registered Email"
              type="email"
              value={email}
              onChange={handleEmailChange}
              variant="outlined"
              margin="normal"
              required
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              sx={{ mt: 2 }}
            >
              Send Password Reset Link
            </Button>
            {/* <Button
              component="a"
              href="company-reset-password"  // or external URL like "https://example.com"
              fullWidth
              variant="contained"
              color="primary"
              sx={{ mt: 2 }}
            >
              Send Password Reset Link
            </Button> */}
          </form>
        </Paper>
      </Container>
    </Box>
  );
};

export default CompanyForgotPassword;
